<template>
  <v-container fill-height fluid grid-list-xl class="pt-3">
    <v-layout wrap>
      <v-flex xs12 class="px-0">
        <v-card class="mb-4 pb-4">
          <v-layout column>
            <v-card-actions class="mb-2 mt-3">
              <v-layout
                row
                wrap
                v-bind:class="{
                  'pl-0': isMobile(),
                  'pl-3': !isMobile(),
                }"
              >
                <v-flex md5 xs12 class="pl-2" v-bind="{ 'py-0': isMobile() }">
                  <v-layout row class="pl-3">
                    <v-card-text
                      style="max-width: 142px;"
                      class="pl-2 font-weight-regular"
                      >Search By Name</v-card-text
                    >
                    <v-btn-toggle
                      mandatory
                      v-model="searchNameMode"
                      class="toggle-button-group mt-2"
                    >
                      <v-btn
                        flat
                        value="yiddish"
                        class="toggle-button search-yiddish-button"
                      >
                        אידיש
                      </v-btn>
                      <v-btn
                        flat
                        value="english"
                        class="toggle-button search-english-button"
                      >
                        English
                      </v-btn>
                    </v-btn-toggle>
                  </v-layout>

                  <v-layout row class="pl-3 mr-2">
                    <v-text-field
                      outline
                      class="mr-2"
                      autocomplete="new-password"
                      :label="getLastNameLabel()"
                      v-model="lastNameSearch"
                      @input="searchByName"
                      :hide-details="isMobile()"
                    ></v-text-field>
                    <v-text-field
                      outline
                      autocomplete="new-password"
                      :label="getFirstNameLabel()"
                      v-model="firstNameSearch"
                      @input="searchByName"
                      :hide-details="isMobile()"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex md4 xs12>
                  <v-card-text
                    v-bind:class="{
                      'pl-1': isMobile(),
                      'pl-0': !isMobile(),
                    }"
                    class="pt-1 font-weight-regular"
                    >Search By Phone Number</v-card-text
                  >
                  <v-layout row>
                    <v-text-field
                      v-bind:class="{
                        'ml-2': isMobile(),
                      }"
                      autocomplete="new-password"
                      outline
                      class="ml-3 mr-4"
                      label="Phone Number"
                      v-model="phoneSearch"
                      mask="###-###-####"
                      @input="searchByPhone"
                    ></v-text-field>
                    <!-- <v-btn
                                            color="default"
                                            dark
                                            style="height: 48px;"
                                            class="ml-3"
                                            @click="searchDialog = true"
                                            >Search Accounts</v-btn
                                        > -->
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-actions>
            <v-layout
              class="mx-4 my-2 headline font-weight-medium"
              row
              v-if="accounts && accounts.length && !isMobile()"
            >
              <div style="width: 15%">Last Name</div>
              <div style="width: 15%">First Name</div>
              <div style="width: 20%">
                Home Phone
              </div>
              <div style="width: 20%">
                Cell Phone
              </div>
              <div style="width: 20%">Address</div>
            </v-layout>
            <v-layout
              class="mx-4 my-2"
              style="border: #999 2px solid; padding: 10px; cursor: pointer;"
              row
              @click="selectAccount(account)"
              v-if="accounts && accounts.length && !isMobile()"
              v-for="(account, index) in accounts"
            >
              <div style="width: 15%">
                {{
                  searchNameMode == "yiddish"
                    ? account.lastNameH
                    : account.lastName
                }}
              </div>
              <div style="width: 15%">
                {{
                  searchNameMode == "yiddish"
                    ? account.firstNameH
                    : account.firstName
                }}
              </div>
              <div style="width: 20%">
                {{ account.homePhone }}
              </div>
              <div style="width: 20%">
                {{ account.cellPhone }}
              </div>
              <div style="width: 20%">{{ account.address1 }}</div>
            </v-layout>
            <v-layout
              class="mx-4 my-2"
              style="border: #999 2px solid; padding: 10px; cursor: pointer;"
              column
              @click="selectAccount(account)"
              v-if="accounts && accounts.length && isMobile()"
              v-for="(account, index) in accounts"
            >
              <div class="font-weight-medium">
                {{ account.lastName + ", " + account.firstName }}
              </div>
              <div>
                {{ account.homePhone }}
              </div>
              <div>
                {{ account.cellPhone }}
              </div>
              <div>{{ account.address1 }}</div>
            </v-layout>
            <div
              class="mt-2 mb-3 font-weight-regular text-xs-center text-warning headline"
              v-if="
                showNoAccountsMessage &&
                  (!accounts || !accounts.length) &&
                  !account.accountID
              "
            >
              No Accounts Found
            </div>
            <v-layout row justify-space-between>
              <div
                v-if="account.accountID && (!accounts || !accounts.length)"
                class="mb-3 pl-3"
              >
                <v-flex xs12 class="pt-0">
                  <v-layout row>
                    <v-layout
                      column
                      v-bind:class="{
                        'ml-2': isMobile(),
                        'ml-4': !isMobile(),
                      }"
                    >
                      <v-card-title primary-title class="pt-0 py-0 mt-3">
                        <div>
                          <h3
                            style="font-weight: 500 !important;"
                            class="headline my-0"
                          >
                            Account ID:
                            {{ account.accountID }}
                          </h3>
                        </div>
                      </v-card-title>
                      <v-card-text class="mb-2 pt-0">
                        <h4 class="card-title font-weight-regular">
                          {{ account.name }}
                        </h4>
                        <p>
                          {{ account.hname }}
                        </p>
                        <p>
                          {{ account.address1 }}
                        </p>
                      </v-card-text>
                      <div class="ml-4 pl-1 mt-0 pb-3">
                        <!-- <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Email:
                                                    </div>
                                                    <div>
                                                        {{
                                                            account.emailAddress
                                                        }}
                                                    </div>
                                                </v-layout> -->
                        <v-layout
                          row
                          class="mb-2"
                          v-for="phone in phonesNumbers"
                        >
                          <div class="font-weight-medium mr-2">
                            {{ getPhoneType(phone.phoneType) }}:
                          </div>
                          <div>
                            {{ phone.phoneNum }}
                          </div>
                        </v-layout>
                      </div>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </div>
              <v-spacer></v-spacer>
            </v-layout>
          </v-layout>
        </v-card>

        <v-card
          v-if="students.length && (!accounts || !accounts.length)"
          class="pa-3 pt-3 pb-0 mt-3"
        >
          <div
            class="font-weight-medium pa-3 title"
            style="border: 1px solid #4caf50;"
            v-for="(student, index) in students"
          >
            <v-layout row class="pl-3 pt-1" v-if="!isMobile()">
              <div class="mr-3">
                {{
                  student.name + " - " + student.hebName + ` (${student.grade})`
                }}
                <span
                  class="ml-2"
                  v-bind:class="{
                    'text-danger':
                      getRegistrationStatus(student) == 'NOT REGISTERED',
                    'text-success':
                      getRegistrationStatus(student) == 'REGISTERED',
                  }"
                >
                  {{ getRegistrationStatus(student) }}</span
                >
              </div>
              <!-- <div class="px-1 mr-3 subheading">
                                <span class="mr-2 font-weight-medium">DOB:</span
                                >{{ student.dob | date }}
                            </div> -->
              <div class="px-1 caption">
                {{ "Term: " + student.term }}
              </div>
            </v-layout>
            <v-layout
              row
              class="pl-3 mt-2 pb-1  subheading font-weight-medium"
              v-if="!isMobile()"
            >
              <div class="width-150">
                Building:<span class="ml-2 font-weight-light">{{
                  student.building
                }}</span>
              </div>
              <div class="width-150">
                Branch:<span class="ml-2 font-weight-light">{{
                  student.branch
                }}</span>
              </div>
              <div class="width-200">
                Room Number:<span class="ml-2 font-weight-light">{{
                  student.roomNumber
                }}</span>
              </div>
              <div class="width-150">
                Section:<span class="ml-2 font-weight-light">{{
                  student.section
                }}</span>
              </div>
              <div class="width-300">
                Teacher:<span class="ml-2 font-weight-light">{{
                  student.teacher
                }}</span>
              </div>
              <div class="" v-if="student.teacher2">
                Teacher 2:<span class="ml-2 font-weight-light">{{
                  student.teacher2
                }}</span>
              </div>
            </v-layout>

            <v-layout column class="pl-3" v-if="isMobile()">
              <div>
                {{
                  student.name + " - " + student.hebName + ` (${student.grade})`
                }}
              </div>
              <div class="mt-2" v-if="student.building">
                Building:
              </div>
              <div class=" font-weight-light">
                {{ student.building }}
              </div>
              <div class="mt-1" v-if="student.roomNumber">
                Room #:
              </div>
              <div class="font-weight-light">
                {{ student.roomNumber }}
              </div>
              <div class="mt-1" v-if="student.teacher">
                Teacher:
              </div>
              <div class="font-weight-light">
                {{ student.teacher }}
              </div>
            </v-layout>

            <!-- <v-divider
                            class="mt-3"
                            v-if="index + 1 < students.length"
                        ></v-divider> -->
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="searchDialog" max-width="1400">
      <v-card>
        <data-grid
          class="accounts-search"
          url="accounts"
          :columns="accountsColumns"
          :title="searchDialogTitle"
          navigationPath="Account View"
          navigationField="accountID"
          v-bind:hideActions="true"
          :onRowClicked="onSearchAccountsRowClicked"
        ></data-grid>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import vueSelect2 from "vue-select";
import { getDomain, sum, groupBy } from "../../utils/helpers.js";
import odata from "odata-client";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
  components: {
    "vue-select2": vueSelect2,
  },
  data: () => ({
    phoneSearch: "",
    firstNameSearch: "",
    lastNameSearch: "",
    accounts: [],

    account: {},

    students: [],

    searchDialogTitle: "Accounts",
    searchDialog: false,
    showNoAccountsMessage: false,
    phonesNumbers: [],
    userBranch: "",
    searchNameMode: "yiddish",

    accountsColumns: [
      {
        sortable: true,
        label: "Name",
        field: "name",
        hidden: false,
        width: "200px",
        filterOptions: {
          enabled: true,
          placeholder: "Search Name..",
        },
      },
      {
        sortable: false,
        label: "Account ID",
        field: "accountID",
        width: "115px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Account ID..",
        },
      },
      {
        sortable: false,
        label: "Hebrew Name",
        width: "250px",
        field: "hname",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Hebrew Name..",
        },
      },
      {
        sortable: false,
        label: "Home Phone",
        field: "homePhone",
        width: "150px",
        hidden: false,
        searchValue: (value) => {
          return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        },
        filterOptions: {
          enabled: true,
          placeholder: "Search Home Phone..",
        },
      },
      {
        sortable: false,
        label: "Cellphone",
        field: "cellPhone",
        width: "150px",
        hidden: false,
        searchValue: (value) => {
          return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        },
        filterOptions: {
          enabled: true,
          placeholder: "Search Cellphone..",
        },
      },
      {
        sortable: false,
        label: "Address",
        field: "address1",
        width: "200px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Address..",
        },
      },
      {
        sortable: false,
        label: "Email",
        field: "emailAddress",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: false,
        label: "Father",
        field: "father",
        hidden: true,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: false,
        label: "Shver",
        field: "shver",
        hidden: true,
        filterOptions: {
          enabled: true,
        },
      },
    ],
  }),
  async created() {
    const branch = this.$store.state.authentication.branch;

    this.userBranch = branch;
  },
  methods: {
    isMobile() {
      return this.$vuetify.breakpoint.name == "xs";
    },
    getLastNameLabel() {
      return this.searchNameMode == "yiddish" ? "לעצטע נאמען" : "Last Name";
    },
    getFirstNameLabel() {
      return this.searchNameMode == "yiddish" ? "טאטעס נאמען" : "Fathers name";
    },
    onSearchAccounts(search, loading) {
      loading(true);

      this.searchAccounts(loading, search);
    },
    async searchAccounts(loading, searchTerm) {
      const request = odata({
        service: getDomain() + "/odata/",
        resources: "accounts",
      }).top(30);

      if (searchTerm) {
        request.filter(`startswith(lastname, '${searchTerm}')`);
      }

      const response = await request.get();

      this.accounts = JSON.parse(response.body).value.map((account) => {
        account.displayName = this.getDisplayName(account);

        return account;
      });

      loading(false);
    },
    onSearchAccountsRowClicked(account) {
      this.searchDialog = false;

      account.displayName = this.getDisplayName(account);

      this.account = account;

      this.onAccountSelected();
    },
    getDisplayName(account) {
      return (
        account.lastName +
        " " +
        account.firstName +
        " (" +
        account.address1 +
        ")"
      );
    },
    getPhoneType(phoneType) {
      switch (phoneType) {
        case "PHON":
          return "Home Phone";
        case "CEL":
          return "Cellphone";
        case "MCEL":
          return "Mother Cellphone";
      }
    },
    async searchByPhone(value) {
      if (value.length < 10) return;

      const accounts = await this.$http.get(
        `api/students/getAccountByPhoneNumber?phoneNumber=${value}` +
          (this.userBranch ? "&branch=" + this.userBranch : "")
      );

      if (accounts.length > 1) {
        this.accounts = accounts.map((account) => {
          account.displayName = this.getDisplayName(account);

          return account;
        });
      } else {
        if (!accounts.length) {
          this.$notify({
            text: "Account Does Not Exist",
            group: "notification",
            type: "warning",
          });

          this.clearSelection();
          this.accounts = [];

          return;
        }

        this.account = accounts[0];

        this.onAccountSelected();
      }
    },
    async searchByName(value) {
      if (!this.firstNameSearch && !this.lastNameSearch) {
        this.clearSelection();
        this.accounts = accounts;

        return;
      }

      this.showNoAccountsMessage = false;

      const url =
        `api/students/getAccountsByName?last=${this.lastNameSearch}&first=${
          this.firstNameSearch
        }&isYiddish=${this.searchNameMode == "yiddish"}` +
        (this.userBranch ? "&branch=" + this.userBranch : "");

      console.log(url);

      const accounts = await this.$http.get(url);

      if (!accounts.length) {
        this.showNoAccountsMessage = true;
        this.clearSelection();
        this.accounts = accounts;

        return;
      }

      if (accounts.length == 1) {
        this.account = accounts[0];

        this.onAccountSelected();
      } else {
        this.accounts = accounts;
      }
    },
    async onSelected(account) {
      if (!account) {
        return this.clearSelection();
      }

      this.accounts = [];

      this.onAccountSelected();
    },
    clearSelection() {
      this.phoneSearch = "";
      this.students = [];
      this.account = {};
    },
    async onAccountSelected() {
      this.students = [];
      this.accounts = [];
      this.firstNameSearch = "";
      this.lastNameSearch = "";
      this.phoneSearch = "";

      this.loadStudents();
      this.loadAccountPhones();
    },
    getRegistrationStatus(student) {
      if (student.isRegistered === null) return "REGISTERED";

      return student.isRegistered ? "REGISTERED" : "NOT REGISTERED";
    },
    selectAccount(account) {
      this.account = account;
      this.accounts = [];
      this.onAccountSelected();
    },
    async loadAccountPhones() {
      const phones = await this.$http.get(
        "api/accounts/getAccountPhones?accountID=" + this.account.accountID
      );

      this.phonesNumbers = phones;
    },
    async loadStudents() {
      const students = await this.$http.get(
        "api/students/getStudentStatuses?accountID=" +
          this.account.accountID +
          (this.userBranch ? "&branch=" + this.userBranch : "")
      );

      this.students = students;

      if (!this.students.length) {
        this.$notify({
          text: "No enrolled students for this account.",
          group: "notification",
          type: "warning",
        });
      }
    },
  },
};
</script>
<style>
.toggle-button {
  font-size: 15px;
  padding: 5px !important;
}
.toggle-button-group {
  height: 29px !important;
  border-radius: 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
  background-color: #afecb2 !important;
  color: #4caf50 !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.search-yiddish-button {
  border-radius: 10px 0px 0px 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.search-english-button {
  border-radius: 0px 10px 10px 0px;
}
</style>
